import { createAsyncThunk } from '@reduxjs/toolkit';

import { setUpdateSaleInvoice } from '../services/setUpdateSaleInvoice';


export const patchUpdateSaleInvoice = createAsyncThunk(
  'invoices/patchUpdateSaleInvoice',
  async ({ invoiceId, updateData}, { getState, dispatch }) => {
    console.log('PATCH updateData', updateData);
    const projectId = getState().projects.selectedProjectId;
    
    const response = await setUpdateSaleInvoice(
      invoiceId,
      projectId,
      updateData
    );
    console.log('response', response);
    return response
  }
);
